<template>
  <v-select
    v-model="selectedItem"
    :items="filteredOptions"
    item-text="label"
    item-value="value"
    :label="dynamicLabel"
    @input="handleInput"
  ></v-select>
</template>

<script>
export default {
  props: {
    options: {
      type: [],
      required: true,
    },label: {
    type: String,
    required: true
  }
  },
  data() {
    return {
      selectedItem: null,
      searchTerm: '',
    };
  },
  computed: {
    dynamicLabel()
    {
      return this.label; 
    },
    filteredOptions() {
      return this.options.filter(option =>
        option.label.toLowerCase().includes(this.searchTerm.toLowerCase())
      );
    },
  },
  methods: {
    handleInput() {
      this.$emit('selected', this.selectedItem);
    },
  },
};
</script>
